import "babel-polyfill";
import Es6Promise from "es6-promise";
import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import Vant from "vant";
import "vant/lib/index.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/publicStyle/common.scss";

require("es6-promise").polyfill();
Es6Promise.polyfill();
Vue.use(Vant);
Vue.use(ElementUI);

Vue.config.productionTip = false;

(function (doc, win) {
  const docEl = win.document.documentElement;
  const resizeEvt =
    "orientationchange" in window ? "orientationchange" : "resize";
  const refreshRem = function () {
    const clientWidth =
      win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
    if (!clientWidth) return;
    let fz;
    fz = (10 * clientWidth) / 375;
    if (fz >= 12) {
      fz = 12;
    }
    docEl.style.fontSize = fz + "px";
  };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, refreshRem, false);
  doc.addEventListener("DOMContentLoaded", refreshRem, false);
  refreshRem();
})(document, window);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
